import { makeAutoObservable } from "mobx";
import { IRmaPyment, PAYMENT_STATUS } from "../../rma-types";

class PaymentStore {
    private _model: IRmaPyment = {} as IRmaPyment;

    constructor(model: IRmaPyment) {
        makeAutoObservable(this, {}, { autoBind: true });
        this._setModel(model);
    }

    private _setModel(model: IRmaPyment) {
        this._model = model;
    }

    public get status(): PAYMENT_STATUS { return this._model.status; }
    public get paymentId(): string { return this._model.payment_id; }
    public get fullAmount(): number | undefined { return this._model._full_amount; }
    /**
     * now not clear where to use discountedAmount in UI
     * TODO: clarify where to use, add implementaion or delete from the store
     */
    public get discountedAmount(): number | undefined { return this._model._discounted_amount; }
    public get currency(): string | undefined { return this._model._currency; }
    public get authorizationExpirationDaysLeft(): number | undefined { return this._model._authorization_expiration_days_left; }
    public get authorizedDate(): string | undefined { return this._model._authorized_date; }
    public get authorizationExpirationDate(): string | undefined { return this._model._authorization_expiration_date; }
    public get captureDate(): string | undefined { return this._model._capture_date; }
    public get cancelDate(): string | undefined { return this._model._cancel_date; }
    public get capturedAmount(): number | undefined { return this._model._captured_amount; }
    public get isHidden(): boolean { return this._model._is_hidden; }

    public get amount() {
        if (this.status === PAYMENT_STATUS.CHARGED) {
            return this.capturedAmount;
        }

        return this.fullAmount;
    }
}

export default PaymentStore;
